interface SuccessMessageProps {
  className?: string;
}

export default function SuccessMessage({ className }: SuccessMessageProps) {
  return (
    <div className={className} style={{ textAlign: "center", padding: "30px 20px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        aria-hidden="true"
        style={{ marginBottom: 16 }}
      >
        <circle cx="40" cy="40" r="36" fill="none" stroke="#4caf50" strokeWidth="3" />
        <polyline
          points="24,40 35,52 56,28"
          fill="none"
          stroke="#4caf50"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h3 style={{ marginBottom: 12 }}>Envoyé !</h3>
      <p style={{ marginBottom: 8 }}>Votre demande a bien été envoyée.</p>
      <p>Un conseiller Komilfo vous recontactera dans les plus brefs délais.</p>
    </div>
  );
}
